module.exports = __webpack_public_path__ + "static/img/ico-ocean.ae452aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-ocean.svg
// module id = EfDD
// module chunks = 1